import React, { useEffect, useState } from 'react';
import { getTransactionByID, getTransactionPdf } from '../services/api.service';
import moment from 'moment';

function TransactionComponent({ transactionId }) {
    const [transaction, setTransaction] = useState(null);

    useEffect(() => {
        const fetchTransaction = async () => {
            try {
                const data = await getTransactionByID(transactionId);
                setTransaction(data);
            } catch (err) {
                console.error('Erreur lors de la récupération de la transaction :', err);
            }
        };
        fetchTransaction();
    }, [transactionId]);

    const handleDownloadPDF = async () => {
        try {
            await getTransactionPdf(transactionId);

        } catch (err) {
            console.error('Erreur lors de la récupération de la transaction :', err);
        }
    };

    if (!transaction) return <div>Chargement...</div>;

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-4">Facture n°{transaction.billingNumber}</h1>
            <p><strong>Montant :</strong> {transaction.amount.toFixed(2)} €</p>
            <p><strong>Date :</strong> {moment(transaction.createdAt).format('DD/MM/YYYY')}</p>

            <button
                onClick={handleDownloadPDF}
                className="mt-6 px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark"
            >
                Télécharger la facture PDF
            </button>
        </div>
    );
}

export default TransactionComponent;
